var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0h16v16H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#60646C",
  fillRule: "evenodd",
  d: "M3.2 2.133c-.589 0-1.066.478-1.066 1.067v9.6c0 .59.477 1.067 1.066 1.067h9.6c.59 0 1.067-.478 1.067-1.067V9.067a.533.533 0 0 0-1.067 0V12.8H3.2V3.2h3.734a.533.533 0 0 0 0-1.067zm10.511.157a.53.53 0 0 1 .156.373v3.204a.533.533 0 0 1-1.067 0V3.954l-5.49 5.49a.533.533 0 1 1-.753-.754l5.49-5.49h-1.913a.533.533 0 0 1 0-1.067h3.2a.53.53 0 0 1 .377.157",
  clipRule: "evenodd"
})));
export default SvgExternalLink;